// Decision: docs/decisions/2026-09-08-gender-field.md (D1/D5). Mirrors the backend Gender enum
// (backend/src/main/java/com/kervolt/oms/enums/Gender.java) exactly — OPTIONAL, nullable, no
// PREFER_NOT_TO_SAY/fourth value without a matching backend + migration change.
export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    OTHER = 'OTHER',
}

// L-5: human-facing wording decided here, not left to whoever builds the <select> — mirrors the
// EMPLOYEE_DOCUMENT_TYPE_LABELS precedent (employee-document.interface.ts).
export const GENDER_LABELS: Record<Gender, string> = {
    [Gender.MALE]: 'Male',
    [Gender.FEMALE]: 'Female',
    [Gender.OTHER]: 'Other',
};

export const ALL_GENDERS = Object.values(Gender);

// MFS disbursement lane (docs/decisions/2026-09-11-garments-mfs-disbursement.md §2). Mirrors the
// backend SalaryPaymentMethod enum minus OTHER, which UserProfileService.update rejects with a
// 400 for this field (V156 CHECK constraint mirrors the same exclusion at the storage layer).
export type PreferredDisbursementMethod = 'CASH' | 'BANK_TRANSFER' | 'MOBILE_BANKING' | 'CHEQUE';

export const PREFERRED_DISBURSEMENT_LABELS: Record<PreferredDisbursementMethod, string> = {
    CASH: 'Cash',
    BANK_TRANSFER: 'Bank transfer',
    MOBILE_BANKING: 'Mobile banking',
    CHEQUE: 'Cheque',
};

export const ALL_PREFERRED_DISBURSEMENT_METHODS = Object.keys(
    PREFERRED_DISBURSEMENT_LABELS
) as PreferredDisbursementMethod[];

export interface IUserProfile {
    id: string;
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    type: string;
    username: string;
    bankName?: string | null;
    bankAccountNumber?: string | null;
    mobileBankingProvider?: string | null;
    mobileBankingAccount?: string | null;
    designation?: string | null;
    employeeCode?: string | null;
    joiningDate?: string | null;
    bankRoutingNumber?: string | null;
    bankBranch?: string | null;
    gender?: Gender | null;
    preferredDisbursementMethod?: PreferredDisbursementMethod | null;
}

export interface IUserProfileUpdate {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    bankName?: string | null;
    bankAccountNumber?: string | null;
    mobileBankingProvider?: string | null;
    mobileBankingAccount?: string | null;
    designation?: string | null;
    employeeCode?: string | null;
    joiningDate?: string | null;
    bankRoutingNumber?: string | null;
    bankBranch?: string | null;
    gender?: Gender | null;
    preferredDisbursementMethod?: PreferredDisbursementMethod | null;
    // Write-only clear list (Task 2 backend): names from CLEARABLE_PROFILE_FIELDS
    // (client/src/utils/profileClearFields.ts) whose value should be cleared. A field named here
    // must NOT also be set elsewhere in the same payload body — the backend rejects set-and-clear
    // with a 400.
    clearFields?: string[];
}
